import React, { useEffect, useState } from "react";
import { PRODUCT } from "../config/product";

const Navbar = ({ onBuyClick }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
    // setScrolled identity is stable; one-time listener setup is intentional.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-6"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
        <div
          data-testid="navbar-logo"
          className="font-display text-xl md:text-2xl font-bold tracking-tighter cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Full<span className="holo-text">Stop</span>
        </div>

        <div
          className={`hidden md:flex items-center gap-1 px-2 py-2 rounded-full transition-all duration-500 ${
            scrolled ? "glass-strong" : ""
          }`}
        >
          {[
            { id: "features", label: "Ventajas" },
            { id: "como-funciona", label: "Cómo funciona" },
            { id: "specs", label: "Ficha técnica" },
            { id: "comprar", label: "Comprar" },
          ].map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => scrollTo(item.id)}
              className="px-4 py-2 text-sm font-body text-white/70 hover:text-white transition-colors rounded-full hover:bg-white/5"
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          data-testid="navbar-waitlist-btn"
          onClick={onBuyClick}
          className="px-5 py-2.5 bg-white text-black text-sm font-medium rounded-full hover:scale-95 active:scale-90 transition-transform duration-300"
          style={{ boxShadow: "0 0 20px rgba(255,255,255,0.2)" }}
        >
          Comprar · {PRODUCT.priceEur.toFixed(2).replace(".", ",")}€
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
